"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stockpileConfigTypes = void 0;
exports.stockpileConfigTypes = {
    SET_ERROR: 'CONFIGURATION STOCKPILE TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'CONFIGURATION STOCKPILE TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'CONFIGURATION STOCKPILE TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'CONFIGURATION STOCKPILE TYPES ON MUTATION',
    ON_SORT_CHANGE: 'CONFIGURATION STOCKPILE TYPES ON SORT CHANGE',
    ON_FILTER_CHANGE: 'CONFIGURATION STOCKPILE TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'CONFIGURATION STOCKPILE TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'CONFIGURATION STOCKPILE TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'CONFIGURATION STOCKPILE TYPES SET SUCCESS MODAL',
    SET_DATA_BRAND: 'CONFIGURATION STOCKPILE TYPES SET DATA BRAND',
    ON_ENTER_EDIT_CLICK: 'CONFIGURATION STOCKPILE TYPES ON ENTER EDIT',
};
